<template>
    <div>
        <h5>Data Model Templates</h5>
        <div><span class="badge text-bg-light">(ready made data models and views you can start with)</span></div>

        <div class="d-flex flex-wrap my-1" :class="model.isMobile ? 'justify-content-center' : ''">
            <div v-for="appTemplate in model.appTemplates" class="p-3">
                <a href="javascript:void(0)" @click="onTemplateClick(appTemplate)" class="no-underline">
                    <app-display :app="appTemplate"></app-display>
                </a>
            </div>
        </div>

        <model-template-modal v-if="showTemplateModal" @noEvent="showTemplateModal = false"
                              :yesEvent="onAppImport" :app-template="currentAppTemplate"></model-template-modal>
    </div>
</template>

<script>
    import AppService from "../services/AppService";
    import AppDisplay from "../components/AppDisplay.vue";
    import ModelTemplateModal from "./ModelTemplateModal.vue";

    export default {
        name: 'DataModelTemplates',
        components: {ModelTemplateModal, AppDisplay},
        data () {
            return {
                model: webase.model,
                service: new AppService(),
                showTemplateModal: false,
                currentAppTemplate: null,
                onAppImport: function () {
                }
            }
        },
        mounted () {
        },
        methods: {
            onTemplateClick(appTemplate) {

                this.currentAppTemplate = appTemplate
                this.showTemplateModal = true

                this.onAppImport = () => {
                    this.service.copyModels(this.model.app.id, this.currentAppTemplate.slug).then((app) => {
                        console.log('Copied models into app from template.')
                        console.log(app)
                        this.$router.push({name: 'open-app', params: {id: app.id}})
                    }).catch((error) => {
                        console.log('Error copying models into app from template.')
                        console.log(error)
                    })
                }
            }
        }
    }
</script>

<style>

</style>
